import en from './en';
import { panelDwiOverrides } from './partials/panelDwiOverrides';
import { panelDepositBonusByLang } from './partials/panelDepositBonusI18n';
import { panelVoucherStatusByLang } from './partials/panelVoucherStatusI18n';
import { panelWithdrawBep20ByLang } from './partials/panelWithdrawBep20I18n';
import { panelDepositVoucherOverrides } from './partials/panelDepositVoucherOverrides';
import { panelInvestmentsOverrides } from './partials/panelInvestmentsI18n';
import { panelStopLossSlotsAssignOverrides } from './partials/panelStopLossSlotsAssignI18n';
import { panelStopLossFlowByLang } from './partials/panelStopLossFlowI18n';
import { panelUserSignupSocialForgotByLang } from './partials/panelUserSignupSocialForgotI18n';
import { panelAgentDashboardByLang } from './partials/panelAgentDashboardI18n';
import { panelAgentReferralsByLang } from './partials/panelAgentReferralsI18n';
import { panelAgentCommissionsByLang } from './partials/panelAgentCommissionsI18n';
import { panelAgentWithdrawByLang } from './partials/panelAgentWithdrawI18n';
import { panelAgentWithdrawUnlockStringsByLang } from './partials/panelAgentWithdrawUnlockStringsI18n';
import { panelAgentTransactionsByLang } from './partials/panelAgentTransactionsI18n';
import { panelAgentLogsByLang } from './partials/panelAgentLogsI18n';
import { panelAgentSettingsByLang } from './partials/panelAgentSettingsI18n';
import { panelAgentNotificationsByLang } from './partials/panelAgentNotificationsI18n';
import { panelAgentTeamByLang } from './partials/panelAgentTeamI18n';
import { panelAgentSignupByLang } from './partials/panelAgentSignupI18n';
import { panelAgentLayoutByLang } from './partials/panelAgentLayoutI18n';
import { panelAgentAuthByLang } from './partials/panelAgentAuthI18n';
import { panelSettingsTransactionsByLang, panelUserExtraByLang } from './partials/panelSettingsTransactions';
import { panelUserPlatformTodayByLang } from './partials/panelUserPlatformTodayI18n';
import { panelStopLossHowLayoutByLang } from './partials/panelStopLossHowLayoutI18n';
import { panelSupportTicketsByLang } from './partials/panelSupportTicketsI18n';
import { panelReferralCurrentRankMinDepositByLang } from './partials/panelReferralRankingI18n';
function m(p) {
  return { ...en, ...p };
}
export default m({
  'common.theme': 'Thème',
  'common.themeLight': 'Clair',
  'common.themeDark': 'Sombre',
  'common.settings': 'Paramètres',
  'common.loading': 'Chargement…',
  'settings.language': 'Langue',
  'settings.savePreferences': 'Enregistrer les préférences',
  'settings.savingPreferences': 'Enregistrement…',
  'auth.gate.userTitle': 'Vérification de la session',
  'auth.gate.userDescription': 'Confirmation de la connexion. Un instant.',
  'auth.gate.agentTitle': 'Vérification de la session',
  'auth.gate.agentDescription': 'Confirmation de la connexion agent. Un instant.',
  'user.layout.sidebarTitle': 'MineMe Utilisateur',
  'user.layout.logout': 'Déconnexion',
  'user.layout.nav.dashboard': 'Tableau de bord',
  'user.layout.nav.deposit': 'Dépôt',
  'user.layout.nav.withdraw': 'Retrait',
  'user.layout.nav.investments': 'Investissements',
  'user.layout.nav.referral': 'Parrainage',
  'user.layout.nav.notifications': 'Notifications',
  'user.layout.nav.stopLoss': 'Stop-Loss',
  'user.layout.nav.transactions': 'Transactions',
  'user.layout.nav.settings': 'Paramètres',
  'agent.layout.logout': 'Déconnexion',
  'agent.layout.nav.dashboard': 'Tableau de bord',
  'auth.user.login.title': 'Connexion utilisateur',
  'auth.user.login.signIn': 'Se connecter',
  'auth.agent.login.title': 'Connexion agent',
  'auth.agent.login.signIn': 'Se connecter',

  'user.page.settings': 'Paramètres',
  'user.settings.intro':
    'Mettez à jour votre profil, la sécurité et les préférences de ce compte.',
  'agent.settings.intro':
    'Mettez à jour votre profil, la sécurité et les préférences d’affichage pour ce compte agent.',

  'settings.tab.profile': 'Profil',
  'settings.tab.security': 'Sécurité',
  'settings.tab.preferences': 'Préférences',

  'settings.shell.loading': 'Chargement des paramètres…',
  'settings.shell.errorTitle': 'Impossible de charger vos paramètres',
  'settings.shell.errorHint':
    'Vérifiez votre connexion, ou déconnectez-vous et reconnectez-vous si la session a expiré.',
  'settings.shell.tryAgain': 'Réessayer',
  'settings.shell.sessionExpired': 'Session expirée — veuillez vous reconnecter',
  'settings.shell.loadProfileFailed': 'Impossible de charger le profil',
  'settings.shell.invalidProfile': 'Réponse de profil invalide',
  'settings.shell.saveFailed': 'Enregistrement impossible',

  'common.themeActive': 'Actuellement actif',
  'common.themeSwitchToDark': 'Passer au thème sombre',
  'common.themeSwitchToLight': 'Passer au thème clair',
  'common.cancel': 'Annuler',

  'settings.currency': 'Devise',
  'settings.selectCurrency': 'Sélectionner la devise',

  'settings.languagePlaceholder': 'Sélectionner la langue',
  'settings.languageOption.englishEn': 'Anglais (EN)',
  'settings.languageOption.spanish': 'Espagnol',
  'settings.languageOption.mandarinChinese': 'Chinois mandarin',
  'settings.languageOption.arabic': 'Arabe',
  'settings.languageOption.french': 'Français',
  'settings.languageOption.hindi': 'Hindi',
  'settings.languageOption.portuguese': 'Portugais',
  'settings.languageOption.russian': 'Russe',
  'settings.languageOption.bengali': 'Bengali',
  'settings.languageOption.german': 'Allemand',
  'settings.languageOption.japanese': 'Japonais',
  'settings.languageOption.korean': 'Coréen',
  'settings.languageOption.italian': 'Italien',

  'settings.notifications.sectionTitle': 'Notifications',
  'settings.notifications.toggle.emailNotifications.label': 'Notifications e-mail',
  'settings.notifications.toggle.emailNotifications.desc': 'Recevoir des mises à jour par e-mail',
  'settings.notifications.toggle.depositAlerts.label': 'Alertes de dépôt',
  'settings.notifications.toggle.depositAlerts.desc': 'Notification lorsque les dépôts sont confirmés',
  'settings.notifications.toggle.withdrawalAlerts.label': 'Alertes de retrait',
  'settings.notifications.toggle.withdrawalAlerts.desc': 'Notification lors des changements de statut de retrait',
  'settings.notifications.toggle.investmentUpdates.label': 'Mises à jour d’investissement',
  'settings.notifications.toggle.investmentUpdates.desc':
    'Intérêts mensuels et notifications de plan',
  'settings.notifications.toggle.referralAlerts.label': 'Alertes de parrainage',
  'settings.notifications.toggle.referralAlerts.desc': 'Notifications sur l’activité de parrainage',

  'user.settings.preferences.summary':
    '{{enabled}} sur {{total}} types d’alertes e-mail sont activés. Ouvrez la fenêtre pour modifier les dépôts, retraits et autres notifications.',
  'user.settings.preferences.manage': 'Gérer les préférences de notification',
  'user.settings.preferences.modalTitle': 'Préférences de notification',
  'user.settings.preferences.modalHint':
    'Choisissez quels e-mails nous envoyons. Vous pouvez modifier cela à tout moment.',
  'user.settings.preferences.toastNotificationsSaved': 'Préférences de notification enregistrées',
  'user.settings.preferences.saveNotifications': 'Enregistrer les notifications',
  'settings.preferences.toastSaved': 'Préférences enregistrées',

  'settings.security.recoveryTitle': 'Phrase de récupération',
  'settings.security.recoveryBefore':
    'Votre phrase de 12 mots a été affichée une seule fois à la création du compte. Nous ne la stockons pas en clair, elle ne peut pas être affichée ici. Pour réinitialiser un mot de passe oublié, utilisez',
  'settings.security.recoveryAfter': 'avec votre phrase enregistrée.',
  'settings.security.forgotPasswordLink': 'Mot de passe oublié',

  'settings.password.title': 'Changer le mot de passe',
  'settings.password.current': 'Mot de passe actuel',
  'settings.password.new': 'Nouveau mot de passe',
  'settings.password.confirm': 'Confirmer le mot de passe',
  'settings.password.show': 'Afficher',
  'settings.password.hide': 'Masquer',
  'settings.password.match': 'Les mots de passe correspondent',
  'settings.password.noMatch': 'Les mots de passe ne correspondent pas',
  'settings.password.errMinLen': 'Au moins 8 caractères requis',
  'settings.password.errSameAsCurrent': 'Le nouveau mot de passe doit être différent de l’actuel',
  'settings.password.errMismatch': 'Les mots de passe ne correspondent pas',
  'settings.password.toastUpdateFailed': 'Impossible de mettre à jour le mot de passe',
  'settings.password.toastUpdated': 'Mot de passe mis à jour',
  'settings.password.submit': 'Mettre à jour le mot de passe',
  'settings.password.updating': 'Mise à jour…',

  'settings.profile.cropPhotoAria': 'Choisir une photo à recadrer',
  'settings.profile.addNameHint': 'Ajoutez votre nom complet dans le formulaire ci-dessous.',
  'settings.profile.activeAccount': 'Compte actif',
  'settings.profile.choosePhoto': 'Choisir une photo',
  'settings.profile.working': 'Traitement…',
  'settings.profile.removePhoto': 'Supprimer la photo',
  'settings.profile.infoTitle': 'Informations du profil',
  'settings.profile.fullName': 'Nom complet',
  'settings.profile.placeholderFullName': 'Votre nom complet',
  'settings.profile.email': 'E-mail',
  'settings.profile.emailLockedHint': 'L’e-mail ne peut pas être modifié',
  'settings.profile.phone': 'Numéro de téléphone',
  'settings.profile.phonePlaceholder': '+33… ou chiffres uniquement',
  'settings.profile.address': 'Adresse',
  'settings.profile.username': 'Nom d’utilisateur',
  'settings.profile.saveChanges': 'Enregistrer les modifications',
  'settings.profile.nameRequired': 'Le nom complet est obligatoire',
  'settings.profile.updatedToast': 'Profil mis à jour',
  'settings.profile.uploadFailed': 'Échec du téléversement',
  'settings.profile.removeFailed': 'Impossible de supprimer la photo',
  'settings.profile.photoUpdated': 'Photo mise à jour',
  'settings.profile.photoRemoved': 'Photo supprimée',
  'settings.profile.avatarFallbackLetter': '?',

  'settings.avatarCrop.hint':
    'Faites glisser pour repositionner, utilisez le curseur pour zoomer. La photo est enregistrée au format carré.',
  'settings.avatarCrop.zoom': 'Zoom',
  'settings.avatarCrop.zoomAria': 'Zoom du recadrage',
  'settings.avatarCrop.savePhoto': 'Enregistrer la photo',
  'settings.avatarCrop.uploading': 'Téléversement…',
  'settings.avatarCrop.toastWaitLoad': 'Attendez le chargement de l’image, puis réessayez.',
  'settings.avatarCrop.toastCropFail': 'Impossible de recadrer cette image. Essayez JPEG ou PNG.',

  'user.profile.cropPhotoTitle': 'Recadrer la photo de profil',
  'agent.profile.cropPhotoTitle': 'Recadrer la photo agent',

  'agent.settings.profile.sponsorLabel': 'Agent parrain',
  'agent.settings.profile.sponsorHelp': 'Défini à l’inscription',
  'agent.settings.profile.suspended': 'Suspendu',

  'common.time.days': 'Jours',
  'common.time.hours': 'Heures',
  'common.time.minutes': 'Minutes',
  'common.time.seconds': 'Secondes',

  'user.layout.balance.available': 'Solde disponible',
  'user.layout.balance.frozen': 'Solde gelé',
  'user.layout.balance.interest': 'Solde des intérêts',
  'user.layout.balance.bonus': 'Solde bonus',

  'user.dashboard.title': 'Tableau de bord',
  'user.dashboard.loadingInvestments': 'Chargement du statut des investissements…',

  'user.dashboard.balance.available': 'Solde disponible',
  'user.dashboard.balance.frozen': 'Solde gelé',
  'user.dashboard.balance.interest': 'Intérêts gagnés',
  'user.dashboard.balance.bonus': 'Solde bonus',

  'user.dashboard.stats.totalInvested': 'Total investi',
  'user.dashboard.stats.netPnl': 'Profit / perte net',
  'user.dashboard.stats.activePlans': 'Plans actifs',

  'user.dashboard.noInvestment.title': 'Aucun investissement actif',
  'user.dashboard.noInvestment.subtitle':
    'Commencez à investir dès aujourd’hui et faites fructifier votre patrimoine avec des rendements attractifs',
  'user.dashboard.noInvestment.cta': 'Découvrir les plans d’investissement',

  'user.dashboard.recentTx.title': 'Transactions récentes',
  'user.dashboard.recentTx.viewAll': 'Tout voir',
  'user.dashboard.recentTx.col.date': 'Date',
  'user.dashboard.recentTx.col.type': 'Type',
  'user.dashboard.recentTx.col.description': 'Description',
  'user.dashboard.recentTx.col.amount': 'Montant',
  'user.dashboard.recentTx.col.status': 'Statut',
  'user.dashboard.recentTx.loading': 'Chargement des transactions récentes…',
  'user.dashboard.recentTx.empty': 'Aucune transaction récente.',

  'user.dashboard.tx.Deposit': 'Dépôt',
  'user.dashboard.tx.Investment': 'Investissement',
  'user.dashboard.tx.Referral': 'Parrainage',
  'user.dashboard.tx.Bonus': 'Bonus',
  'user.dashboard.tx.Withdrawal': 'Retrait',
  'user.dashboard.tx.E-Voucher': 'Bon électronique',
  'user.dashboard.tx.Stop-Loss': 'Stop-loss',

  'user.dashboard.st.Completed': 'Terminé',
  'user.dashboard.st.Active': 'Actif',
  'user.dashboard.st.Pending': 'En attente',
  'user.dashboard.st.Failed': 'Échoué',

  'user.dashboard.invest.planFallback': 'Plan',
  'user.dashboard.invest.activeBadge': 'Actif',
  'user.dashboard.invest.detail.amountInvested': 'Montant investi',
  'user.dashboard.invest.detail.currentValue': 'Valeur actuelle',
  'user.dashboard.invest.detail.pl': 'P / P',
  'user.dashboard.invest.detail.interestRate': 'Taux d’intérêt',
  'user.dashboard.invest.detail.perMonth': '{{pct}} % par mois',
  'user.dashboard.invest.detail.duration': 'Durée',
  'user.dashboard.invest.detail.months': '{{n}} mois',
  'user.dashboard.invest.detail.startDate': 'Date de début',
  'user.dashboard.invest.detail.nextWithdrawal': 'Prochain retrait',
  'user.dashboard.invest.countdownTitle': 'Prochain retrait dans',
  'user.dashboard.invest.progress': 'Progression',
  'user.dashboard.invest.progressPct': '{{pct}} % effectué',
  'user.dashboard.invest.earlyWithdraw': 'Retrait anticipé',
  'user.dashboard.invest.planChip': '{{name}} n°{{num}}',

  'user.dashboard.invest.modal.title': 'Avertissement — retrait anticipé',
  'user.dashboard.invest.modal.investmentAmount': 'Montant de l’investissement :',
  'user.dashboard.invest.modal.platformFee': 'Frais plateforme ({{pct}} %) :',
  'user.dashboard.invest.modal.interestForfeited': 'Intérêts perdus :',
  'user.dashboard.invest.modal.youWillReceive': 'Vous recevrez :',
  'user.dashboard.invest.modal.confirmHint': 'Saisissez CONFIRM pour continuer',
  'user.dashboard.invest.modal.placeholderConfirm': 'CONFIRM',
  'user.dashboard.invest.modal.confirmWithdraw': 'Confirmer le retrait',
  'user.dashboard.invest.modal.cancelling': 'Annulation…',
  'user.dashboard.invest.toast.cancelled': 'Investissement annulé',
  'user.dashboard.invest.toast.cancelFailed': 'Annulation impossible',

  'notifications.bell.triggerAria': 'Notifications',
  'notifications.bell.title': 'Notifications',
  'notifications.bell.loading': 'Chargement…',
  'notifications.bell.loadErrorSubtitle': 'Impossible de charger les notifications',
  'notifications.bell.unreadOne': '1 mise à jour non lue',
  'notifications.bell.unreadMany': '{{count}} mises à jour non lues',
  'notifications.bell.allCaughtUp': 'Vous êtes à jour',
  'notifications.bell.markAllRead': 'Tout marquer comme lu',
  'notifications.bell.empty': 'Aucune notification pour le moment',
  'notifications.bell.emptyError': 'Impossible de charger les notifications',
  'notifications.bell.viewAll': 'Tout voir',
  'notifications.bell.markReadAria': 'Marquer comme lu',
  'notifications.bell.time.justNow': 'à l’instant',
  'notifications.bell.time.secondsAgo': 'il y a {{n}} s',
  'notifications.bell.time.minutesAgo': 'il y a {{n}} min',
  'notifications.bell.time.hoursAgo': 'il y a {{n}} h',
  'notifications.bell.time.daysAgo': 'il y a {{n}} j',

  'user.layout.investorAccount': 'Compte investisseur',

  ...panelSettingsTransactionsByLang.fr,
  ...panelReferralCurrentRankMinDepositByLang.fr,
  ...panelUserExtraByLang.fr,
  ...panelDwiOverrides.fr,
  ...panelDepositBonusByLang.fr,
  ...panelVoucherStatusByLang.fr,
  ...panelWithdrawBep20ByLang.fr,
  ...panelDepositVoucherOverrides.fr,
  ...panelInvestmentsOverrides.fr,
  'user.investments.card.dailyProfit': 'Profit journalier',
  'user.investments.card.earningDays': 'Jours ouvrables',
  'user.investments.card.earningDaysValue': '{{count}} jours ouvrables',
  'user.investments.card.expectedProfit': 'Profit attendu',
  'user.investments.card.investLimit': "Limite d'investissement",
  'user.investments.card.investLimitLine': '{{count}}× en {{days}} jours',
  'user.investments.card.investLimitReached':
    "Vous avez atteint la limite d'investissement pour ce plan sur la période en cours.",
  'user.investments.card.limitReached': 'Limite atteinte',
  ...panelStopLossSlotsAssignOverrides.fr,
  ...panelStopLossFlowByLang.fr,
  ...panelUserSignupSocialForgotByLang.fr,
  ...panelAgentDashboardByLang.fr,
  ...panelAgentReferralsByLang.fr,
  ...panelAgentCommissionsByLang.fr,
  ...panelAgentWithdrawByLang.fr,
  ...panelAgentWithdrawUnlockStringsByLang.fr,
  'agent.withdraw.unlock.loadingTitle': 'Vérification du statut des retraits…',
  'agent.withdraw.unlock.loadingSubtitle':
    'Chargement de votre progression de parrainage et des exigences',
  'agent.withdraw.form.loadingTitle': 'Chargement des détails de retrait…',
  'agent.withdraw.form.loadingHint':
    'Veuillez patienter pendant le chargement du solde et du statut',
  'agent.withdraw.unlock.requirementMet': 'Exigence remplie',
  'agent.withdraw.unlock.minDepositHint':
    'Seuls les utilisateurs parrainés comptent (pas les sous-agents). Chacun doit avoir au moins ${{amount}} de dépôts complétés.',
  ...panelAgentTransactionsByLang.fr,
  ...panelAgentLogsByLang.fr,
  ...panelAgentSettingsByLang.fr,
  ...panelAgentNotificationsByLang.fr,
  ...panelAgentTeamByLang.fr,
  ...panelAgentSignupByLang.fr,
  ...panelAgentLayoutByLang.fr,
  ...panelAgentAuthByLang.fr,
  ...panelUserPlatformTodayByLang.fr,
  ...panelStopLossHowLayoutByLang.fr,
  ...panelSupportTicketsByLang.fr,
});
